angular.module('webcomm')
    .directive('logDisplay', function () {
        return {
            templateUrl: 'app/logDisplay/logDisplay.html',
            replace: true,
            controller: 'LogDisplay',
            controllerAs: 'logDisplay'
        }
    })
    .controller('LogDisplay', ['$rootScope', 'logger', function ($rootScope, logger) {
        this.showLog = false;

        this.hideLog = ($event) => {
            this.showLog = false;
        }

        this.levelClasses = {
            'debug': 'text-muted',
            'log': 'text-primary',
            'warn': 'text-warning',
            'info': 'text-info',
            'error': 'text-danger'
        };

        this.selectAll = ($event) => {
            var range = document.createRange();
            range.setStart($("#log-list-panel")[0], 0);
            range.setEnd($("#log-display-range-marker")[0], 0);
    
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
        }

        this.logMessages = logger.messages;

        let unbindOnShowLogDisplay = $rootScope.$on('logDisplay.show', (e, x) => {
            this.logMessages = logger.messages;
            this.showLog = true;
        });
        
        $rootScope.$on('$destroy', () => unbindOnShowLogDisplay());
    }]);